import StepperAnalyticsBase from '@/components/analytics/StepperAnalytics';
import { useDynamicPageContext } from '@/contexts/DynamicPageContext';
import { useContext, useMemo } from 'react';
import { DashboardContext } from '../../contexts/DashboardContext';
import { extractTextFromQuillTrimmed } from '../../utils/quill';

/**
 * StepperAnalytics wrapper for ManageDynamicPage context.
 * Uses DynamicPageContext to get the selected dynamic page and analytics filters.
 */
export default function StepperAnalytics() {
  const { forms } = useContext(DashboardContext);
  const { selectedDynamicPage, analyticsFilters } = useDynamicPageContext();

  // Map forms to { id, name } array for the base component
  const formsArray = useMemo(() => {
    return (
      forms?.map((f) => ({
        id: f.id,
        name: extractTextFromQuillTrimmed(f.data().name),
      })) ?? []
    );
  }, [forms]);

  if (!selectedDynamicPage) {
    return null;
  }

  return (
    <StepperAnalyticsBase
      dynamicPageId={selectedDynamicPage.id}
      forms={formsArray}
      analyticsFilters={analyticsFilters}
    />
  );
}
